import { useToastStore } from './store'

const useToast = () => {
    const showToast = useToastStore((state) => state.showToast)

    return { showToast }
}

export default useToast
